import { Box } from '@chakra-ui/react'

import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { OfferSmeCompare } from '../../../containers/offers/OfferSmeCompare'

export const Step3 = () => {
  return (
    <Section>
      <Container>
        <StepsContent step={3}>
          <Steps icon="briefcase" />

          <InsuranceInfo />

        </StepsContent>
      </Container>

      <Box sx={{ px: 4 }}>
        <OfferSmeCompare />
      </Box>
    </Section>
  )
}
